var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.show ? _vm.__get_style([_vm.$u.addStyle(_vm.customStyle)]) : null
  var g0 = _vm.show && !_vm.webviewHide ? _vm.$u.addUnit(_vm.size) : null
  var g1 = _vm.show && !_vm.webviewHide ? _vm.$u.addUnit(_vm.size) : null
  var g2 = _vm.show && _vm.text ? _vm.$u.addUnit(_vm.textSize) : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        g1: g1,
        g2: g2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }